import React from "react";
import ICON from "components/cmp_icon/cmp_icon";

import './cmp_stat.css';


export default function CMP_STAT({ set_currentStatus, var_APIstatus, var_currentStatus, var_providers, var_reviewed, var_status }) {

    //  variable declarations ------------------------------------------------------------------------------------------



    //  event listeners ------------------------------------------------------------------------------------------------




    //  async functions ------------------------------------------------------------------------------------------------




    //  API calls ------------------------------------------------------------------------------------------------------




    //  event functions ------------------------------------------------------------------------------------------------

    function onClick_stat(){
        set_currentStatus(var_APIstatus)
    }


    // RENDER CONTAINER ================================================================================================

    return (

        <div className='card stat providers' onClick={() => onClick_stat()}>
            <div>
                <div className='text--base'>{var_status}</div>
                {var_currentStatus === var_APIstatus &&
                    <div className='icon--current'>
                        <ICON name='checkmark' className='icon' alt='checkmark icon'/>
                    </div>
                }
            </div>
            <div className='text--md medium'>{var_providers && var_providers.toLocaleString() || '0'}</div>
            <div className='text--sm'>{var_reviewed && var_reviewed.toLocaleString() || '0'} to be reviewed</div>
        </div>

    )
}